export const onRequest = async (config) => {
  const controller = new AbortController();
  return {
    ...config,
    signal: controller.abort(),
  };
};
export const onRequestError = (error) => {
  if (error.response === undefined) {
  }
  return error;
};

export const onResponse = (response) => {
  if (response.status === 200) {
    if (response.data) {
      return response.data;
    } else return response;
  }
};
export const onResponseError = (error) => {
  if (error.response === undefined) {
    return;
  } else if (error.response.status === 401) {
    console.log("error.request", error.request);
    console.log("error.response", error.response);
    return;
  }  else {
      return;
  }
  return error;
};

